import React from 'react';
import Icon from '../../../components/AppIcon';
import { ClassSession } from '../types';

interface SessionInfoProps {
  session: ClassSession;
  participantCount: number;
}

const SessionInfo = ({ session, participantCount }: SessionInfoProps) => {
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('ro-RO', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getSessionDuration = () => {
    const now = new Date();
    const start = session.startTime;
    const diffInMinutes = Math.floor((now.getTime() - start.getTime()) / (1000 * 60));
    
    if (diffInMinutes < 60) {
      return `${diffInMinutes} min`;
    }
    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;
    return `${hours} h ${minutes} min`;
  };

  return (
    <div className="bg-card border-b border-border p-4">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <h1 className="text-xl font-semibold text-foreground mb-1 truncate">
            {session.title}
          </h1>
          <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
            <div className="flex items-center gap-1.5">
              <Icon name="BookOpen" size={16} />
              <span>{session.subject}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Icon name="Clock" size={16} />
              <span>
                {formatTime(session.startTime)} - {formatTime(session.endTime)}
              </span>
            </div>
            <div className="flex items-center gap-1.5">
              <Icon name="Users" size={16} />
              <span>{participantCount} participanți</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Icon name="Timer" size={16} />
              <span>Durată: {getSessionDuration()}</span>
            </div>
          </div>
        </div>

        {session.isRecording && (
          <div className="flex items-center gap-2 px-3 py-2 bg-error/10 border border-error rounded-md">
            <div className="w-2 h-2 rounded-full bg-error animate-pulse" />
            <span className="text-sm font-medium text-error">Înregistrare</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SessionInfo;
